import axios from '../helpers/axiosConfig';
import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../helpers/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import getBaseUrl from '../helpers/utility';

const PersonnelsMilitaireRetraite = () => {
  const baseUrl = getBaseUrl();

  const navigate = useNavigate();
  const [personnels, setPersonnels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPersonnels = async () => {
      toast.info('Chargement en cours ...');
      const token = localStorage.getItem('accessToken');

      try {
        const response = await axios.get('/personnel', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.data;

        const today = new Date();
        const yearInTwoYears = today.getFullYear();

        const personnelsRetraite = data.personnels.filter((personnel) => {
          if (personnel.typePers === 'MILITAIRE') {
            if (personnel.datenaisse) {
              const birthDate = new Date(personnel.datenaisse);
              const retirementAge = personnel.grade.anneeretraite;

              if (!retirementAge) {
                console.log(`Retraite manquante pour ${personnel.nom}`);
                return false;  // Exclure ce personnel si l'âge de retraite est manquant
              }

              const retirementYear = birthDate.getFullYear() + retirementAge;

              // Vérifier les années de retraite et appliquer le filtrage
              //console.log(`Nom: ${personnel.nomprenom}, Année de retraite: ${retirementYear}, Aujourd'hui: ${today.getFullYear()}, 2 ans: ${yearInTwoYears}`);

              // Filtrage des personnels dans les 2 prochaines années
              return retirementYear >= today.getFullYear() && retirementYear <= yearInTwoYears;
            }
          }
          return false;  // Si ce n'est pas un personnel militaire ou sans date de naissance
        });

        // Trier les personnels par année de retraite en ordre croissant
        personnelsRetraite.sort((a, b) => {
          const retirementYearA = new Date(a.datenaisse).getFullYear() + a.grade.anneeretraite;
          const retirementYearB = new Date(b.datenaisse).getFullYear() + b.grade.anneeretraite;
          return retirementYearA - retirementYearB; // Tri par année de retraite en ordre croissant
        });

        setPersonnels(personnelsRetraite);
      } catch (err) {
        toast.error(err.message);
      }
      setLoading(false);
    };

    fetchPersonnels();
  }, []);

  return (
    <div className="container pt-5 mt-5 ">
      {personnels.length === 0 ? (
        <div className="alert alert-info p-3 text-center">Chargement des données...</div>
      ) : (
        <div>
          <h2>Retraité dans les années suivantes</h2>
          {personnels && <div className="alert alert-danger p-3"> Résultats trouvés : {personnels.length} </div>}
          <table className="table table-striped">
            <thead className="table-dark">
              <tr>
                <td>Grade</td>
                <td>Nom et prénoms</td>
                <td>Date de naissance</td>
                <td>Ets. / Sce / Compagnie</td>
                <td>Date retraite</td>
                <td>Photo</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              {personnels.map((personnel) => (
                <tr key={personnel.id}>
                  <td>{personnel.grade.name}</td>
                  <td>{personnel.nomprenom}</td>
                  <td>{personnel.datenaisse}</td>
                  <td>
                    {personnel.etsouservice && personnel.etsouservice.name}  {personnel.compagnie && personnel.compagnie.name}
                  </td>
                  <td>{new Date(personnel.datenaisse).getFullYear() + personnel.grade.anneeretraite}</td>
                  <td>
                    <img src={`${baseUrl}/images/personnels/${personnel.filename}`} width="50px" height="50px" alt="" />
                  </td>
                  <td>
                    <i style={{ cursor: 'pointer' }} className="fa fa-eye" onClick={() => navigate(`/personnel/${personnel.id}`)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PersonnelsMilitaireRetraite;
